/** @format */

import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardHeader,
	CardBody,
	CardText,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
	Button,
} from "reactstrap";
import Loader from "../components/Loader";
import jquery from "jquery";
import "react-notifications/lib/notifications.css";
// import {NotificationContainer, NotificationManager} from 'react-notifications';
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "animate.css/animate.min.css";
import "animate.css/animate.compat.css";
import "animate.css";
import { store } from "react-notifications-component";
import { withRouter } from "react-router-dom";
import { XORCipher } from "./../global/XORCipher"
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
} from "../global/browserFunctions";
import { login } from "../global/url";
import { showNotification } from "../global/notification";

class Login extends Component {
	constructor(props) {
		super(props);
		//console.log('props',this.props);
		this.state = { email: "", password: "", loading: false, hidden: true };

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.toggleShow = this.toggleShow.bind(this);
		var loggedin = getCookie("log");
		if (loggedin) this.GoToPage("/home"); // Check whether customer is logged in 1h before, if yes redirect to home

		document.title = "Login | Register";
	}

	GoToPage(path) {
		this.props.history.push(path); //Component has no access to history, so we pass from props
	}
	toggleShow() {
		this.setState({ hidden: !this.state.hidden }); //Hide/Show password field
	}
	handleChange(event) {
		//Handles change from multiple input
		var target = event.target;
		var name = target.name;
		if (name == "email") var value = target.value.trim();
		else var value = target.value;
		this.setState({ [name]: value });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.setState({ loading: true });
		var self = this;
		var tstamp = Date.parse(new Date()).toString()
		var encrypt = XORCipher.encode(tstamp, this.state.password)
		var query =
			"&email=" +
			encodeURIComponent(this.state.email) +
			"&password=" +
			encodeURIComponent(encrypt) + "&timeStamp=" + encodeURIComponent(tstamp) +
			"&status=login";
		jquery
			.ajax({
				url: login + query,
				dataType: "jsonp",
			})
			.done(function (data) {
				console.log(data);
				data = JSON.parse(data);
				data = data.length ? data[0] : "";
				self.setState({ loading: false });
				if (data == "") {
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occured. Please try again later"
					);
				} else {
					if (data.responseString == "FAILURE") {
						var message = unescape(data.responseMessage);
						showNotification("Information!", "warning", message);
					} else if (data.responseString == "SUCCESS") {
						setCookie("log", true, 1);
						setCookie("name", data.Name, 1);
						setCookie("country", data.Location == 1 ? "US" : "CANADA", 1);
						setCookie("currency", data.Currency, 1);
						setCookie("pricelevel", data.priceLevel, 1);
						setCookie("location", data.Location, 1);
						setCookie("customid", data.customerID, 1);
						self.GoToPage("/home");
					} else {
						showNotification(
							"Sorry",
							"danger",
							"An unknown error occured. Please try again later"
						);
					}
				}
			});
	}
	render() {
		return (
			<Col lg='5' className='mb-5'>
				<Loader loading={this.state.loading} />
				<Card>
					<CardHeader className='py-4 px-5'>
						<h5 className='mb-0'> Login </h5>
					</CardHeader>
					<CardBody className='p-5'>
						<Form onSubmit={this.handleSubmit}>
							<FormGroup>
								<Label className='form-label' for='emailLogin'>
									Email
								</Label>
								<Input
									id='emailLogin'
									name='email'
									type='text'
									onChange={this.handleChange}
									value={this.state.email}
									pattern='^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
									required
								/>
							</FormGroup>
							<a href='/forgot-password' id='forgot'>
								Forgot Password ?
							</a>
							<FormGroup>
								<Label className='form-label' for='passwordLogin'>
									Password
								</Label>
								<Input
									id='passwordLogin'
									name='password'
									onChange={this.handleChange}
									value={this.state.password}
									type={this.state.hidden ? "password" : "text"}
									required
								/>
								<span
									className='fa fa-fw fa-eye field-icon-password'
									onClick={this.toggleShow}
								></span>
							</FormGroup>
							<Button color='dark' type='submit' onClick={this.addNotification}>
								<i className='fa fa-sign-in-alt mr-2' /> Log in
							</Button>
						</Form>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default Login;
